import axios from "axios";

import { API_URL } from "../utils/api";

//функция записи в БД
export async function recordToDataBase(state) {
  try {
    await axios.post(`${API_URL}/masters.json`, state);
  } catch (error) {
    console.log(error);
  }
}

export const dateFinder = (searchDate, allDates) => {
  //формируем текстовую выбранную дату
  const date = searchDate.toString().split(" ").slice(0, 4).join(" ");

  //формируем массив дат мастера
  const arrDates = Object.keys(allDates);

  //модифицируем массив дат мастера
  const modifyArr = arrDates.map((item) =>
    item.toString().split(" ").slice(0, 4).join(" ")
  );

  //находим номер индекса выбранного дня у мастера
  const index = modifyArr.indexOf(date);

  //возвращаем индекс
  return index;
};

//генерируем рабочий день
export function addWorkingDay(obj, date) {
  obj[date] = {
    "07:20": {
      status: "",
    },
    "07:40": {
      status: "",
    },
    "08:00": {
      status: "",
    },
    "08:20": {
      status: "",
    },
    "08:40": {
      status: "",
    },
    "09:00": {
      status: "",
    },
    "09:20": {
      status: "",
    },
    "09:40": {
      status: "",
    },
    "10:00": {
      status: "",
    },
    "10:20": {
      status: "",
    },
    "10:40": {
      status: "",
    },
    "11:00": {
      status: "",
    },
    "11:20": {
      status: "",
    },
    "11:40": {
      status: "",
    },
    "12:00": {
      status: "",
    },
    "12:20": {
      status: "",
    },
    "12:40": {
      status: "",
    },
    "13:00": {
      status: "",
    },
    "13:20": {
      status: "",
    },
    "13:40": {
      status: "",
    },
    "14:00": {
      status: "",
    },
    "14:20": {
      status: "",
    },
    "14:40": {
      status: "",
    },
    "15:00": {
      status: "",
    },
    "15:20": {
      status: "",
    },
    "15:40": {
      status: "",
    },
    "16:00": {
      status: "",
    },
    "16:20": {
      status: "",
    },
    "16:40": {
      status: "",
    },
    "17:00": {
      status: "",
    },
    "17:20": {
      status: "",
    },
    "17:40": {
      status: "",
    },
    "18:00": {
      status: "",
    },
    "18:20": {
      status: "",
    },
    "18:40": {
      status: "",
    },
    "19:00": {
      status: "",
    },
    "19:20": {
      status: "",
    },
    "19:40": {
      status: "",
    },
    "20:00": {
      status: "",
    },
    "20:20": {
      status: "",
    },
    "20:40": {
      status: "",
    },
    "21:00": {
      status: "",
    },
  };
}

//генерируем рабочие дни
export function generateWorkingDays() {
  const now = new Date();

  const obj = {};

  for (let i = 0; i < 30; i++) {
    const day = new Date(
      +now.getFullYear(),
      +now.getMonth(),
      +now.getDate() + i
    );

    const date = new Date(day.getFullYear(), now.getMonth(), now.getDate() + i);

    addWorkingDay(obj, date);
  }
  return obj;
}
